import axios from "axios"
import { useUserStore } from "./stores/user-store"
import { useGlobalStore } from "./stores/global-store"
import router from "./router"

async function createAxiosInstance(baseURL: string) {
  const response = await fetch("/config.json?v=" + new Date().getTime())
  const config = await response.json()
  const store = useUserStore()
  const globalStore = useGlobalStore()

  const instance = axios.create({
    baseURL: baseURL,
    timeout: config.timeout,
  })

  instance.interceptors.request.use(
    (config) => {
      globalStore.showLoading()
      // If request is other than GET, show saving indicator
      if (config.method && config.method.toUpperCase() !== "GET") {
        globalStore.savingStarted()
      }

      const token = store.user?.token

      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }

      return config
    },
    (error) => {
      globalStore.hideLoading()
      return Promise.reject(error)
    },
  )

  instance.interceptors.response.use(
    (response) => {
      globalStore.hideLoading()
      globalStore.savingFinished()
      return response
    },
    (error) => {
      globalStore.hideLoading()
      globalStore.savingFinished()
      const redirectTo = error.response?.status === 401 ? "home" : error.response?.status === 403 ? "403" : null
      if (redirectTo && router.currentRoute.value.name !== redirectTo) {
        setTimeout(() => {
          router.replace({ name: redirectTo })
        })
      }
      return Promise.reject(error)
    },
  )
  return instance
}

export default createAxiosInstance
